import type { CityConfig } from "../city-template/types";

export const radcliffConfig: CityConfig = {
  city: "Radcliff",
  state: "Kentucky",
  stateAbbr: "KY",
  slug: "radcliff",
  route: "/cities/radcliff",
  title: "Emergency Passport Radcliff, KY | Fast Passport Renewal | Hardin County",
  metaDescription: "Emergency passport and expedited passport services in Radcliff, KY — as fast as 24 hours. Fast passport renewal and child passport expediting for Hardin County and Fort Knox area travelers. A+ BBB rated, registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Radcliff, KY",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Radcliff and Hardin County travelers get their expedited passports as quickly as 24 hours. Serving Fort Knox, Elizabethtown, and the I-65 corridor. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Radcliff%20Kentucky%20Hardin%20County%20suburban%20area%20near%20Fort%20Knox%20military%20base%20at%20golden%20hour%2C%20rolling%20Kentucky%20hills%20with%20Fort%20Knox%20area%20landscape%2C%20small%20town%20community%20with%20tree-lined%20streets%2C%20warm%20sunset%20light%20over%20the%20I-65%20corridor%20in%20Kentucky%2C%20clean%20modern%20cityscape%20photography%2C%20lush%20green%20landscape%2C%20no%20visible%20text%20or%20people%2C%20wide%20panoramic%20view&width=1800&height=700&seq=radcliff-hero-001&orientation=landscape",
  heroImageAlt: "Radcliff Kentucky near Fort Knox with Hardin County rolling hills and suburban landscape",
  geoPosition: "37.7645;-85.9453",
  geoPlacename: "Radcliff, Kentucky",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "77 W Jackson Blvd, Suite 1200, Chicago, IL 60604",
    distance: "Located in downtown Chicago — approximately 320 miles from Radcliff via I-65",
  },
  nearbyCitiesZips: [
    { name: "Radcliff", zips: "40160" },
    { name: "Elizabethtown", zips: "42701, 42702" },
    { name: "Fort Knox", zips: "40121, 40122" },
    { name: "Shepherdsville", zips: "40165" },
    { name: "Louisville", zips: "40201, 40202, 40203, 40204, 40205, 40206, 40207, 40208, 40209, 40210, 40211, 40212, 40213, 40214, 40215, 40216, 40217, 40218, 40219, 40220, 40221, 40222, 40223, 40224, 40225, 40228, 40229, 40231, 40232, 40233, 40234, 40235, 40236, 40241, 40242, 40243, 40245, 40250, 40251, 40252, 40253, 40255, 40256, 40257, 40258, 40259, 40261, 40266, 40268, 40269, 40270, 40272, 40280, 40281, 40282, 40283, 40285, 40287, 40289, 40290, 40291, 40292, 40293, 40294, 40295, 40296, 40297, 40298, 40299" },
    { name: "Vine Grove", zips: "40175" },
    { name: "Muldraugh", zips: "40155" },
    { name: "West Point", zips: "40177" },
    { name: "Leitchfield", zips: "42754" },
    { name: "Brandenburg", zips: "40108" },
    { name: "Hodgenville", zips: "42748" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Hardin County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels to our processing center" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Elizabethtown", route: "/cities/elizabethtown" },
    { name: "Fast passport renewal in Louisville", route: "/cities/louisville" },
    { name: "Emergency passport help in Bowling Green", route: "/cities/bowling-green" },
    { name: "Urgent passport services in Shepherdsville", route: "/shepherdsville" },
    { name: "Same-day passport help in Fort Knox", route: "/fort-knox" },
    { name: "Passport courier services in Hopkinsville", route: "/cities/hopkinsville" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Radcliff remotely via secure courier. We do not have a walk-in office in Radcliff — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Hardin County travelers.",
  fpcOfficeDistance: "Serving all of Hardin County and the Fort Knox area",
  serviceAreaIntro: "From downtown Radcliff to the Fort Knox gates, from the Elizabethtown border to the Shepherdsville corridor — Fast Passport Center serves the entire Radcliff community. We regularly help travelers from Elizabethtown, Vine Grove, and Shepherdsville get their passports fast.",
  nearbyCitiesIntro: "We serve Radcliff and all surrounding Hardin County cities including Elizabethtown, Fort Knox, Shepherdsville, Louisville, Vine Grove, Muldraugh, West Point, Leitchfield, Brandenburg, and Hodgenville. If you are in Hardin County, the Fort Knox area, or the I-65 corridor, we have you covered.",
  howItWorksIntro: "Most Radcliff travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Radcliff and Hardin County travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Radcliff and Hardin County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Radcliff? Here are the most common ones we hear from Hardin County travelers.",
  statePageRoute: "/states/kentucky",
  statePageName: "Kentucky",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "3–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–3",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns and budget fights",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Hardin County international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Jennifer L.",
      location: "Radcliff, KY",
      rating: 5,
      text: "Military spouse here at Fort Knox. My passport expired two weeks before our PCS move to Germany. Fast Passport Center got me a renewal in 4 days. They understand military timelines.",
      service: "Passport Renewal",
    },
    {
      name: "Marcus H.",
      location: "Elizabethtown, KY",
      rating: 5,
      text: "Emergency trip to visit family in the Philippines. They processed my passport in 48 hours. The agent was so helpful and patient. I highly recommend them.",
      service: "Emergency Passport",
    },
    {
      name: "Tanya G.",
      location: "Radcliff, KY",
      rating: 5,
      text: "First-time passport for my son's school trip to Spain. They walked me through the entire process and we had the passport in 6 days.",
      service: "Child Passport",
    },
    {
      name: "Kevin D.",
      location: "Fort Knox, KY",
      rating: 5,
      text: "Lost my passport before my deployment leave. They got me a replacement in 36 hours. Fast, professional, and reliable.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "radcliff-1",
      name: "Radcliff Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1200 S Wilson Rd",
      city: "Radcliff",
      state: "KY",
      zip: "40160",
      phone: "(270) 351-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.5 miles from downtown Radcliff",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major facility for Hardin County. Appointments required. Call ahead to confirm passport acceptance times.",
      icon: "ri-mail-line",
    },
    {
      id: "radcliff-2",
      name: "Elizabethtown Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "150 N Main St",
      city: "Elizabethtown",
      state: "KY",
      zip: "42701",
      phone: "(270) 765-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.3 miles from downtown Elizabethtown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Largest facility in the area. High volume — book appointments early.",
      icon: "ri-mail-line",
    },
    {
      id: "radcliff-3",
      name: "Hardin County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "120 E Dixie Ave",
      city: "Elizabethtown",
      state: "KY",
      zip: "42701",
      phone: "(270) 765-2171",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "0.1 miles from Elizabethtown Courthouse",
      website: "https://www.hardincountygov.com/",
      websiteLabel: "Hardin County Clerk",
      notes: "County-level passport acceptance. Appointments recommended for faster service.",
      icon: "ri-government-line",
    },
    {
      id: "radcliff-4",
      name: "Shepherdsville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "545 Conestoga Pkwy",
      city: "Shepherdsville",
      state: "KY",
      zip: "40165",
      phone: "(502) 543-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.5 miles from downtown Shepherdsville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Bullitt County. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 5.5 hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Hardin County photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Hardin County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Radcliff applicants show up with incorrect checks and have to reschedule.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Chicago regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Hardin County families.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Radcliff travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Radcliff or Elizabethtown." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Radcliff address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Radcliff before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Radcliff for travelers with urgent international flights. Our registered couriers hand-deliver documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 5.5 hour drive to Chicago." },
    { q: "How fast can I renew my passport in Radcliff?", a: "Fast Passport Center offers fast passport renewal in Radcliff in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "Where are the closest passport acceptance facilities in Radcliff?", a: "Popular options include the Radcliff Post Office (40160), Elizabethtown Post Office (42701), Hardin County Clerk (42701), and Shepherdsville Post Office (40165). All require appointments. We help you find the most convenient location." },
    { q: "Can I expedite a child passport in Radcliff?", a: "Yes. Fast Passport Center expedites child passports in Radcliff for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs." },
    { q: "Do I need to drive to the Chicago Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities." },
    { q: "How much does expedited passport service cost in Radcliff?", a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed. Contact us for a personalized quote." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Elizabethtown", address: "1600 Ring Rd, Elizabethtown, KY 42701", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walmart — Elizabethtown", address: "100 Walmart Dr, Elizabethtown, KY 42701", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Walgreens — Shepherdsville", address: "545 Conestoga Pkwy, Shepherdsville, KY 40165", hours: "Mon–Sun: 7AM–11PM" },
    { name: "FedEx Office — Louisville", address: "4621 Shelbyville Rd, Louisville, KY 40207", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    {
      name: "Circuit Court Clerk — Hardin County",
      address: "120 E Dixie Ave, Elizabethtown, KY 42701",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Driver's license and REAL ID. Appointment recommended.",
      featured: true,
    },
    {
      name: "Circuit Court Clerk — Bullitt County",
      address: "545 Conestoga Pkwy, Shepherdsville, KY 40165",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "REAL ID and driver's license renewals. Online booking available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "SDF",
      name: "Louisville Muhammad Ali International",
      distance: "40 miles from Radcliff",
      address: "600 Terminal Dr, Louisville, KY 40209",
      note: "The primary international airport for Hardin County. Major hub for international flights.",
      flightUrl: "https://www.flylouisville.com/",
      flightLabel: "Louisville Airport",
      featured: true,
    },
    {
      code: "BWG",
      name: "Bowling Green-Warren County Regional",
      distance: "50 miles from Radcliff",
      address: "985 Three Springs Rd, Bowling Green, KY 42104",
      note: "Regional airport with limited commercial service.",
      flightUrl: "https://www.bgwcairport.com/",
      flightLabel: "Bowling Green Airport",
      featured: false,
    },
    {
      code: "LEX",
      name: "Blue Grass Airport (Lexington)",
      distance: "75 miles from Radcliff",
      address: "4000 Terminal Dr, Lexington, KY 40510",
      note: "Alternative regional airport with domestic flights.",
      flightUrl: "https://www.bluegrassairport.com/",
      flightLabel: "Blue Grass Airport",
      featured: false,
    },
  ],
};